// import router from '@/router';

import store from '@/store';

const defaultAction = async (context, promise, callback = null) => {
    context.commit('startRequest');
    context.commit('clearError');
    context.commit('clearErrors');

    try {
        const response = await promise;
        if (typeof response.data.success !== 'undefined' && response.data.success === true) {
            context.commit('clearError');
            if (typeof callback === 'function') {
                await callback(response.data);
            } else {
                return response;
            }
        } else if (typeof response.data.error !== 'undefined' && response.data.error === 'Validation failed') {
            context.commit('setError', 'validation');
            context.commit('setErrors', response.data.modelstate);
        } else {
            context.commit('setError', 'general');
        }
    } catch (err) {
        if (typeof err.response !== 'undefined' && typeof err.response.status !== 'undefined' && err.response.status === 401) {
            // router.push({ name: 'login' });
            store.dispatch('auth/login');
            return null;
        }
        context.commit('setError', 'server');
    } finally {
        context.commit('endRequest');
    }

    return null;
};

export default {
    defaultAction,
};
